import React, { useState } from "react";
import { Modal, Button, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import TickLogo from "../../../../images/tick.png";
import CrossLogo from "../../../../images/cross.png";
import ChatLogo from "../../../../images/chat.png";
import "./QA.css";
import CustomDropDown from "./QaDropDown";
import EmptyChat from "../../../../images/EmptyChat.png";
import {
  CommentUpdate,
  brandCommentSaver,
  srtLogs,
} from "../../../../Redux/actions/Srt/Srt";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { toast } from "../../../../UIComponents/Toast";
import Info from "../../../../images/info.png";
import BeatLoader from "react-spinners/BeatLoader";

const QA = ({
  data,
  qaStatus,
  commentReciever,
  reqNo,
  dataOfRow,
  statusFor,
  user,
  salesSample,
}) => {
  const [mappedData, setMappedData] = useState([]);
  useEffect(() => {
    if (data?.qa_cmt && Array.isArray(data.qa_cmt)) {
      const sortedData = [...data.qa_cmt].sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );
      const mapData = sortedData.reduce((acc, item) => {
        const existingUserIndex = acc.findIndex(
          (user) => user.username === item.username
        );

        if (existingUserIndex !== -1) {
          acc[existingUserIndex].comments.push(item.comments);
          // acc[existingUserIndex].last_comment = item.comments;
          // acc[existingUserIndex].last_id = item.id;
          // acc[existingUserIndex].updated_at = item.updated_at;
          // acc[existingUserIndex].comment_count = item.comment_count;
        } else {
          acc.push({
            username: item.username,
            comments: [item.comments],
            last_comment: item.comments,
            last_id: item.id,
            updated_at: item.updated_at,
            comment_count: item.comment_count,
          });
        }

        return acc;
      }, []);
      setMappedData(mapData);
    } else {
      setMappedData([]);
    }
  }, [data]);

  const dispatch = useDispatch();
  const profileDetailData = useSelector(
    (state) => state?.Profile?.profileDetails?.role
  );
  const brandNameFromApi = useSelector((state) => state?.Srt?.srtBrandNames);
  const userDetails = useSelector((state) => state?.Profile?.profileDetails);
  const userNameMicrosoft = useSelector(
    (state) => state?.Profile?.graphCompleteData?.displayName
  );
  const logsDetailData = useSelector((state) => state?.Srt?.srtLogsData);
  const SrtLogsLoading = useSelector((state) => state?.Srt?.srtLogsLoading);
  const [isCommentPopupOpen, setIsCommentPopupOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [reqNumber, setReqNumber] = useState("");
  const [TooltipInputText, setTooltipInputText] = useState("");
  const [commentUpdateReqData, setCommentUpdateReqData] = useState({});
  const [commentData, setCommentData] = useState([]);
  const [indexValue, setIndexValue] = useState("");
  const [commentDataModified, setCommentDataModified] = useState();
  const [onEditBtnClicked, setOnEditBtnClicked] = useState(false);
  const [hoverClick, setHoverClick] = useState("hover");
  const [comment_count, setCommentCount] = useState();
  const [userExists, setUserExists] = useState();
  const [isLogsModalOpen, setisLogsModalOpen] = useState(false);

  const toolTipCommentsData = () => {
    return {
      style: dataOfRow?.style,
      brand: dataOfRow?.brand,
      factory: dataOfRow?.factory,
      season: dataOfRow?.season,
      color_code: dataOfRow?.color_code,
      request_no: reqNumber,
      size: commentUpdateReqData?.size,
      comments: TooltipInputText,
      username: userNameMicrosoft,
      role_name: userDetails?.role,
      comment_count,
      comment_type: "QA",
      sale_sample: salesSample,
    };
  };

  const toolTipCommentsUpdateData = (id, count) => {
    return {
      style: dataOfRow?.style,
      brand: dataOfRow?.brand,
      factory: dataOfRow?.factory,
      season: dataOfRow?.season,
      color_code: dataOfRow?.color_code,
      request_no: reqNumber,
      size: commentUpdateReqData?.size,
      comments: TooltipInputText,
      username: userNameMicrosoft,
      role_name: userDetails?.role,
      comment_count: count,
      id: id,
      comment_type: "QA",
      sale_sample: salesSample,
    };
  };

  const [filteredUserName, setFilteredUserName] = useState([]);
  const onCommentEdit = (item, index, requestNo, dataOfRow) => {
    setTooltipInputText(item?.last_comment);
    setCommentCount(item?.comment_count);
    setIndexValue(index);
    setReqNumber(requestNo);
    setCommentUpdateReqData(dataOfRow);
    setOnEditBtnClicked(true);
  };

  const userName = [];
  useEffect(() => {
    if (data?.qa_cmt && Array?.isArray(data?.qa_cmt)) {
      data?.qa_cmt?.map((item, index) => {
        userName.push(item?.username);
        if (userName && Array?.isArray(userName)) {
          const filteredUser = userName.filter(
            (name) => name === userNameMicrosoft
          );
          setFilteredUserName(filteredUser);
        }
      });
    }
  }, [data]);

  const VALID_CHAR_REGEX = /^[\x09\x0A\x0D\x20-\x7E]*$/;
  const [hasInvalidAscii, setHasInvalidAscii] = useState(false);

  const ontooltipInputTextChange = (e) => {
    const input = e.target.value;
    const containsInvalidAscii = !VALID_CHAR_REGEX.test(input);
    setHasInvalidAscii(containsInvalidAscii);
    setTooltipInputText(input);
  };

  const onTickClick = (id, count) => {
    if (!TooltipInputText) {
      toast.error("Please add the comment");
    } else if (
      !hasInvalidAscii &&
      (profileDetailData !== "Admin" || profileDetailData !== "Brand")
    ) {
      dispatch(
        CommentUpdate(toolTipCommentsUpdateData(id, count), brandNameFromApi)
      );
      setHasInvalidAscii(false);
    }
  };

  const onCloseClick = () => {
    setOnEditBtnClicked(false);
  };

  const onBrandEmptyCommentClick = (count, requestNo, dataOfRow) => {
    setCommentCount(count);
    setReqNumber(requestNo);
    setTooltipInputText("");
    setCommentUpdateReqData(dataOfRow);
    setIsModalOpen(true);
    setIsCommentPopupOpen(false);
  };

  const onBrandCommentClick = (count, requestNo, dataOfRow) => {
    setCommentCount(count + 1);
    setReqNumber(requestNo);
    setTooltipInputText("");
    setCommentUpdateReqData(dataOfRow);
    setIsModalOpen(true);
    setIsCommentPopupOpen(false);
  };

  useEffect(() => {
    if (mappedData) {
      const User = mappedData.some((item) =>
        item.username.includes(userNameMicrosoft)
      );
      setUserExists(User);
    }
  }, [mappedData]);

  const comment =
    data?.qa_cmt && Array?.isArray(data?.qa_cmt) ? (
      <>
        <p className="tooltip-comment">
          <b>Comment</b>
        </p>
        {mappedData?.map((item, index) => {
          return (
            <React.Fragment key={item.last_id}>
              <div className="tooltip-name-date-container">
                <b className="tooltip-comment">{item?.username}</b>
                <p className="tooltip-comment-date-time">{item?.updated_at}</p>
              </div>
              {onEditBtnClicked && item?.username === userNameMicrosoft ? (
                <>
                  <TextArea
                    value={TooltipInputText ? TooltipInputText : ""}
                    rows={5}
                    onChange={ontooltipInputTextChange}
                  />
                  {hasInvalidAscii && (
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      Invalid characters detected: Only printable ASCII
                      characters are allowed.
                    </p>
                  )}
                  <div className="tick-cross-container">
                    <img
                      className="tick-and-cross"
                      src={TickLogo}
                      alt="tick"
                      style={{
                        opacity: hasInvalidAscii || !TooltipInputText ? 0.4 : 1,
                        cursor:
                          hasInvalidAscii || !TooltipInputText
                            ? "not-allowed"
                            : "pointer",
                      }}
                      onClick={() => {
                        if (!hasInvalidAscii && TooltipInputText) {
                          onTickClick(item?.last_id, item?.comment_count);
                        }
                      }}
                    />
                    <img
                      className="tick-and-cross"
                      onClick={onCloseClick}
                      src={CrossLogo}
                      alt="cross"
                    />
                  </div>
                </>
              ) : (
                <div>
                  <div className="comment-tooltip">
                  {item.comments.map((comment, index) => (
                    <div key={index}>
                      {comment
                        .split(/(?<=\n)(?=[a-zA-Z])/)
                        .map((line, lineIndex) => (
                          <p key={lineIndex} className="tooltip-comment">
                            {lineIndex === 0 ? `${index + 1}. ${line}` : line}
                          </p>
                        ))}
                    </div>
                  ))}
                  </div>
                  {item?.username == userNameMicrosoft ? (
                    <div className="edit-add-container">
                      <div className="edit-icon-container">
                        <EditOutlined
                          onClick={() =>
                            onCommentEdit(item, index, reqNo, dataOfRow)
                          }
                        />
                      </div>
                      <div>
                        <PlusOutlined
                          className="comment-edit"
                          onClick={() =>
                            onBrandCommentClick(
                              item?.comment_count,
                              reqNo,
                              dataOfRow
                            )
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </React.Fragment>
          );
        })}
        {!userExists ? (
          <div className="add-button-container">
            <div>
              <PlusOutlined
                className="comment-edit"
                onClick={() => onBrandEmptyCommentClick(0, reqNo, dataOfRow)}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    ) : (
      <></>
    );

  const handleCancel = () => {
    setTooltipInputText("");
    setHasInvalidAscii(false);
    setIsModalOpen(false);
  };

  const onSaveHandle = () => {
    if (!TooltipInputText) {
      toast.error("Please add the comment");
      return;
    }

    if (
      !hasInvalidAscii &&
      (profileDetailData !== "Admin" || profileDetailData !== "Brand")
    ) {
      dispatch(brandCommentSaver(toolTipCommentsData(), brandNameFromApi));
      setIsModalOpen(false);
      setHasInvalidAscii(false);
      setIsCommentPopupOpen(true)
    }
  };

  useEffect(() => {
    if (data?.qa_cmt && Array.isArray(data?.qa_cmt)) {
      setCommentData(data.qa_cmt);
    } else {
      setCommentData([]);
    }
  }, [data]);

  const onTooltipOpen = (value) => {
    if (value === true) {
      setHoverClick("click");
    } else {
      setHoverClick("hover");
    }
  };

  const onLogsClick = () => {
    const season = dataOfRow?.season;
    const factory = dataOfRow?.factory;
    const style = dataOfRow?.style;
    const color = dataOfRow?.color_code;
    const size = dataOfRow?.size;
    if (season && factory && style && salesSample && color && size) {
      dispatch(
        srtLogs(
          style,
          factory,
          size,
          season,
          color,
          reqNo === null ? null : reqNo === 0 ? 0 : reqNo === -1 ? -1 : reqNo,
          salesSample
        )
      );
    }
    setisLogsModalOpen(true);
  };
  const handleLogCancel = () => {
    setisLogsModalOpen(false);
  };
  return (
    <div className="srt-table-data-five">
      <div className="dropdown-chatlogo-data-five">
        <div className="srt-dropdown-common">
          <CustomDropDown
            requestNo={reqNo}
            rowData={dataOfRow}
            data={data}
            statusForBrand={statusFor}
            defaultValue={qaStatus}
            salesSample={salesSample}
          />
        </div>
        {commentData.length === 0 ? (
          <img
            className="comment-logo"
            onClick={() => onBrandEmptyCommentClick(0, reqNo, dataOfRow)}
            src={EmptyChat}
            alt="chatlogo"
          />
        ) : (
          // <Tooltip
          //   onOpenChange={onTooltipOpen}
          //   trigger={hoverClick}
          //   overlayInnerStyle={{
          //     width: "fit-content",
          //     height: "fit-content",
          //     padding: "20px",
          //     color: "black",
          //   }}
          //   color={"white"}
          //   placement="right"
          //   title={comment}
          // >
          //   <img
          //     className="comment-logo"
          //     // onClick={() => onBrandCommentClick(reqNo, dataOfRow)}
          //     src={ChatLogo}
          //     alt="chatlogo"
          //   />
          // </Tooltip>
          <img
            className="comment-logo"
            src={ChatLogo}
            alt="chatlogo"
            onClick={() => {
  setIsModalOpen(false);
  setisLogsModalOpen(false);
  setIsCommentPopupOpen(true);
}}
          />
        )}
        <div style={{ marginLeft: "5px", cursor: "pointer" }} onClick={onLogsClick}>
          <img height={15} width={15} src={Info} alt="info" />
        </div>
      </div>
      <Modal
        title="Comment"
        open={isModalOpen}
        onCancel={handleCancel}
        okText={"save"}
        className="commentAddPopup"
        footer={null}
      >
        <TextArea
          value={TooltipInputText}
          rows={5}
          onChange={ontooltipInputTextChange}
        />
        {hasInvalidAscii && (
          <p style={{ color: "red", fontWeight: "bold" }}>
            Invalid characters detected: Only printable ASCII characters are
            allowed.
          </p>
        )}

        <div className="srt-buttons">
          <Button className="modal-cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            className="modal-yes-button"
            onClick={onSaveHandle}
            disabled={hasInvalidAscii || !TooltipInputText}
          >
            Save
          </Button>
        </div>
      </Modal>
      <Modal
        className="srt-logs-modal-container"
        footer={null}
        title={
          <div className="srt-logs-header">
            <div className="logs-sent-header-details">
              <span>
                SRT LOGS : <b>QA</b>
              </span>
              <span>{dataOfRow?.season}</span>
              <span>{dataOfRow?.style}</span>
              <span>{dataOfRow?.factory}</span>
              <span>Size: {dataOfRow?.size}</span>
            </div>
            <div className="srt-logs-req">
              REQ : {reqNo === null || reqNo === 0 || reqNo === -1 ? "" : reqNo}
            </div>
          </div>
        }
        open={isLogsModalOpen}
        onCancel={handleLogCancel}
        width={790}
      >
        {SrtLogsLoading ? (
          <BeatLoader
            color={"#0C3D5E"}
            loading={SrtLogsLoading}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
            cssOverride={{
              margin: "30px auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              borderColor: "#0C3D5E",
            }}
          />
        ) : (
          <>
            {logsDetailData?.[0]?.qa?.logs?.length == 0 ||
            logsDetailData.length == 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p>
                  <b>No logs yet</b>
                </p>
              </div>
            ) : (
              logsDetailData?.[0]?.qa?.logs?.map((log) => (
                <div className="srt-logs-container" key={log?.log_id}>
                  <p className="log-number-container">{log?.log_id}</p>
                  <div className="srt-logs">
                    <div>
                      <p>
                        {log?.timestamp}
                        <span>
                          {" "}
                          - <b>{log?.updated_by}</b>
                        </span>
                      </p>
                    </div>
                    <div className="logs-btn-container">
                      {log?.type === "Status" ? (
                        <>
                          <button
                            className={
                              log?.previous_value === "Approved"
                                ? "logs-approved"
                                : log?.previous_value === "Incomplete"
                                ? "logs-incomplete"
                                : log?.previous_value === "Dropped"
                                ? "logs-dropped"
                                : log?.previous_value === "Rejected"
                                ? "logs-dropped"
                                : log?.previous_value === "Override"
                                ? "logs-override"
                                : log?.previous_value === "Hold"
                                ? "logs-hold"
                                : log?.previous_value === "Set_up_Ready"
                                ? "logs-setupready"
                                : log?.previous_value === null
                                ? "logs-default"
                                : "logs-default"
                            }
                          >
                            {log?.previous_value !== null &&
                            log?.previous_value !== "" &&
                            log?.previous_value !== "undefined" &&
                            log?.previous_value !== "null"
                              ? log.previous_value
                              : "-"}
                          </button>
                          <p>-------&gt;</p>
                          <button
                            className={
                              log?.new_value === "Approved"
                                ? "logs-approved"
                                : log?.new_value === "Incomplete"
                                ? "logs-incomplete"
                                : log?.new_value === "Dropped"
                                ? "logs-dropped"
                                : log?.new_value === "Rejected"
                                ? "logs-dropped"
                                : log?.new_value === "Override"
                                ? "logs-override"
                                : log?.new_value === "Hold"
                                ? "logs-hold"
                                : log?.new_value === "Set_up_Ready"
                                ? "logs-setupready"
                                : log?.new_value === null
                                ? "logs-default"
                                : "logs-default"
                            }
                          >
                            {log?.new_value !== null &&
                            log?.new_value !== "" &&
                            log?.new_value !== "undefined" &&
                            log?.new_value !== "null"
                              ? log.new_value
                              : "-"}
                          </button>
                        </>
                      ) : (
                        <p
                          style={{
                            whiteSpace: "normal",
                            wordBreak: "break-all",
                          }}
                        >
                          {log?.new_value ? log?.new_value : "NA"}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </>
        )}
      </Modal>
      <Modal
        title=""
        open={isCommentPopupOpen}
        onCancel={() => setIsCommentPopupOpen(false)}
        footer={null}
        width={600}
        className="commentPopup"
      >
        {comment}
      </Modal>
    </div>
  );
};

export default QA;
